import React from "react";
import ApexChart from "react-apexcharts";
import {
  Box,
  Select,
  MenuItem,
  FormControl,
  Card,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const NotaryPerformanceChart = (props) => {
  const { year, setYear, years, handleChartValues, chartSeries } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const handleYearChange = (event) => {
    setYear(event.target.value);
    handleChartValues();
  };

  const state = {
    options: {
      chart: {
        height: isMobile ? 250 : isTablet ? 300 : 350,
        type: "line",
        stacked: false,
        toolbar: {
          show: false,
        },
        fontFamily: "inherit",
      },
      colors: ["#28a745", "#ff9800", "#f44336"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: [1, 2, 5],
        curve: "smooth",
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
        },
      },
      fill: {
        opacity: [0.85, 0.25, 1],
        gradient: {
          inverseColors: false,
          shade: "light",
          type: "vertical",
          opacityFrom: 0.85,
          opacityTo: 0.55,
          stops: [0, 100, 100, 100],
        },
      },
      labels: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      markers: {
        size: 0,
      },
      xaxis: {
        type: "month",
        labels: {
          style: {
            fontSize: isMobile ? "10px" : "12px",
          },
          rotate: isMobile ? -45 : 0,
        },
      },
      yaxis: {
        title: {
          text: "Jobs",
          style: {
            fontSize: isMobile ? "10px" : "12px",
          },
        },
        min: 0,
        labels: {
          formatter: function (value) {
            return parseInt(value).toFixed(0);
          },
          style: {
            fontSize: isMobile ? "10px" : "12px",
          },
        },
      },
      tooltip: {
        shared: true,
        intersect: false,
        style: {
          fontSize: isMobile ? "12px" : "14px",
        },
        y: {
          formatter: (y) => {
            if (typeof y !== "undefined") {
              return `${y.toFixed(0)} jobs`;
            }
            return y;
          },
        },
      },
    },
  };

  return (
    <Card
      sx={{
        position: "relative",
        p: {
          xs: 1, // Mobile: smaller padding
          sm: 2, // Tablet and up: original padding
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          mt: 4,
        }}
      >
        <FormControl
          variant="filled"
          sx={{
            zIndex: 999,
            position: "absolute",
            top: isMobile ? -40 : -35,
            right: {
              xs: 0, // Mobile: closer to edge
              sm: 30, // Tablet and up: original position
            },
            m: 1,
            minWidth: {
              xs: 120, // Mobile: smaller width
              sm: 200, // Tablet and up: original width
            },
            backgroundColor: "white",
            borderRadius: 1,
            boxShadow: 1,
          }}
        >
          <Select
            value={year}
            onChange={handleYearChange}
            inputProps={{ "aria-label": "Without label" }}
            size={isMobile ? "small" : "medium"}
            sx={{
              fontSize: {
                xs: "0.875rem", // Mobile: smaller text
                sm: "1rem", // Tablet and up: original text
              },
            }}
          >
            {years?.map((year) => (
              <MenuItem
                key={year}
                value={year}
                sx={{
                  fontSize: {
                    xs: "0.875rem", // Mobile: smaller text
                    sm: "1rem", // Tablet and up: original text
                  },
                }}
              >
                {year}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <ApexChart
          options={state.options}
          series={chartSeries}
          type="line"
          height={isMobile ? 250 : isTablet ? 300 : 350}
        />
      </Box>
    </Card>
  );
};

export default NotaryPerformanceChart;
